import MapView from '../components/MapView'

function Dashboard() {
  return (
    <div className="map-container">
      <MapView center={[1.3521, 103.8198]} zoom={12} />
    </div>
  )
}

export default Dashboard
